var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { useLogger, useTelemetryClient, } from "../../../core/services";
import { ErrorCode, getError, isIError } from "../../../utilities";
/**
 * Error boundary to capture any unhandled errors while rendering
 */
var ErrorBoundaryInner = /** @class */ (function (_super) {
    __extends(ErrorBoundaryInner, _super);
    function ErrorBoundaryInner(props) {
        var _this = _super.call(this, props) || this;
        _this.displayName = "ErrorBoundaryInner";
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundaryInner.prototype.componentDidCatch = function (error, info) {
        var errorMessage = "message: " + error.message + " \n stack: " + info.componentStack;
        var iError = isIError(error)
            ? error
            : getError(error.message, ErrorCode.ReactErrorBoundary);
        this.props.logger.error(errorMessage);
        this.props.telemetryClient.logEvent(__assign({ EventName: "ErrorBoundaryCaughtError", Message: iError.message, ErrorCode: iError.code, ComponentErrorStack: info.componentStack }, (this.props.telemetryData || {})));
        this.setState({ hasError: true });
    };
    ErrorBoundaryInner.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.fallbackUI, fallbackUI = _b === void 0 ? null : _b;
        var hasError = this.state.hasError;
        return hasError ? fallbackUI : children;
    };
    return ErrorBoundaryInner;
}(React.PureComponent));
export var ErrorBoundary = function (props) {
    var logger = useLogger().logger;
    var telemetryClient = useTelemetryClient().telemetryClient;
    return (_jsx(ErrorBoundaryInner, __assign({}, props, { logger: logger, telemetryClient: telemetryClient }), void 0));
};
ErrorBoundary.displayName = "ErrorBoundary";
